import styled from 'styled-components';

export const ActionsContainer = styled.div`
  padding-bottom: 10px;
`;

export default ActionsContainer;
